import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  Navigate,
  useParams
} from "react-router-dom";
import Start from "./Component/Start/Start";
import SignUp from "./Component/SignUp/SignUp";
import Details from "./Component/Details/Details";
import Step from "./Component/Step/Step";
import SubscriptionPlan from "./Component/SubscriptionPlan/SubscriptionPlan";
import AboutBusiness from "./Component/AboutBusiness/AboutBusiness";
import BusinessDetails from "./Component/BusinessDetails/BusinessDetails";
import "react-toastify/dist/ReactToastify.css";
import AgentDetail from "./Component/AgentDetails/AgentDetail";
import AiAssistant from "./Component/AiAssistant/AiAssistant";
import BusinessLocation from "./Component/BusinessLocation/BusinessLocation";
import SecureRoute from "./Pages/SecureRoute";
import Dashboard from "./Component/Dashboard/Dashboard";
import RexAgent from "./Component/RexAgent/RexAgent";
import Plans from "./Component/Plans/Plans";
import MessagePlan from "./Component/MessagePlan/MessagePlan";
import Delete from "./Component/Delete/Delete";
import SubscriptionFlow from "./Component/Checkout/SubscriptionFlow";
import Calendar from "./Component/Celender/Calendar";
import BusinessServices from "./Component/BusinessServices/BusinessServices";
import TotalsCallsList from "./Component/TotalsCallsList/TotalsCallsList";
import CallTransfer from "./Component/CallTransfer/CallTransfer";
import CallDetails from "./Component/CallDetails/CallDetails";
import BusinessServicesNEXT from "./Component/BusinessServices/BusinessServicesNEXT";
import CalInfo from "./Component/Dashboard/CalInfo";
import EditProfile from "./Component/EditProfile/EditProfile";
//... Edit Screen Start ....//
import EditAgentNew from "./Component/EditAgentNew/EditAgentNew";
import EditBusinessType from "./Component/EditBusinessType/EditBusinessType";
import EditServicesOffered from "./Component/EditServicesOffered/EditServicesOffered";
import EditPublic from "./Component/EditPublic/EditPublic";
import EditBusinessDetail from "./Component/EditBusinessDetail/EditBusinessDetail";
import EditLanguage from "./Component/EditLanguage/EditLanguage";
import EditGender from "./Component/EditGender/EditGender";
import EditNameAvtar from "./Component/EditNameAvtar/EditNameAvtar";
//... Edit Screen End ....//
import { useEffect, useState } from "react";
import RoutePersistence from "./Component/RoutePersistence/RoutePersistence";
import WidgetGuidePage from "./Component/WidgetGuidePage/WidgetGuidePage";
import BusinessListing from "./Component/BusinessListing/BusinessListing";
import Test from "./utils/Test";
import CallSetting from "./Component/CallSetting/CallSetting";
import ConnectCalenderAPI from "./Component/ConnectCalenderAPI/ConnectCalanderAPI";
import AssignNumber from "./Component/AssignNumber/AssignNumber";
import Thankyou from "./Component/ThankyouPage/Thankyou";
import CancelPage from "./Component/CancelPage/CancelPage";
import IntegrateAgent from "./Component/Integrate-agent/Integrate-agent";
import AgentSetupHelp from "./Component/AgentSetupHelp/AgentSetupHelp";
import Plan from "./Component/Plans/Plans";
import Planss from "./Component/Plan/Plan";
import Documentation from "./Component/Documentation/Documentation";
import RedirectHandler from "./utils/RedirectHandler ";
import PreventPullToRefresh from "./Component/PreventPullToRefresh/PreventPullToRefresh";
import Thankyou2 from "./Component/ThankyouPage2/Thankyou2";
import Number from "./Component/assign/Number";
import CallRecording from "./Component/CallRecording/CallRecording";
import RaiseTickets from "./Component/Tickets/RaiseTickets";
import CreateTicketModal from "./Component/Tickets/CreateTicketModal";
import CreateTicket from "./Component/Tickets/CreateTicket";
import Fileinfo from "./Component/AgentDetails/FileInfo/Fileinfo";
import ForcePortraitOnly from "./utils/ForcePortraitOnly";
import decodeToken from "./lib/decodeToken";
import { initNotificationSocket } from "./utils/initNotificationSocket";
import { checkAgentExistence, getUserNotifications } from "./Store/apiStore";
import { io } from "socket.io-client";
import { useNotificationStore } from "./Store/notificationStore";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import NotificationView from "./Component/Notifications/NotificationView";
import ThankYouPage from "./Component/hubspotThankyouPage/HubspotThankyou";
import OwnPlan from './Component/OwnPlan/OwnPlan'
// import CustomPlan from "./Component/OwnPlan/CustomPlan";
import BuildPlan from "./Component/BuildPlan/BuildPlan";
import CustomPlan from "./Component/BuildPlan/CustomPlan";
import PublicWidgetPage from "./Component/PublicWidgetPage/PublicWidgetPage";
import EmpoweringIndustries from "./Component/EmpoweringIndustries/EmpoweringIndustries";
function App() {
  const [refreshKey, setRefreshKey] = useState(0);
  const token = localStorage.getItem("token");
  const lastRoute = localStorage.getItem("lastVisitedRoute");
  const decoded = decodeToken(token);
  const navigate = useNavigate()
  const [agentCode, setAgentCode] = useState(null);
  const [isChecking, setIsChecking] = useState(true)
  const [renderStatusPage, setRenderStatusPage] = useState(false)
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  
  console.log(agentCode, "agentCodeagentCodeagentCode")
  //Public Widget Integration
  useEffect(() => {
    const path = window.location.pathname;   // "/jk"
    const code = path.replace("/", "");      // "jk"

    const checkAgent = async () => {
      if (code) {
        setAgentCode(code);  // save code

        try {
          const res = await checkAgentExistence(code);
          if (res?.state === true) {
          setRenderStatusPage(true);
        } else {
          navigate("/")
          window.location.reload()
        }
        } catch (err) {
          console.error("Error checking agent:", err);
        }
      }

      setIsChecking(false);
    };

    checkAgent();
  }, []);

  if (isChecking) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-600 text-lg">
        {/* Checking agent link... */}
      </div>
    );
  }
  if (renderStatusPage && agentCode) {
    return <PublicWidgetPage agentCode={agentCode} />;
  }
  if (!isChecking && !agentCode) {
    return (
  <>
  <EmpoweringIndustries/>
  </>

    );
  }

  return (
    <>
      {/* <ForcePortraitOnly /> */}
      <div className="DesktopPlusMobile">
        <div className="ForDesktop">
          <img src="svg/Rexpt-Logo.svg" />
          <h1>
            Launch Your <b>AI Receptionist</b> with Rexpt.in
          </h1>
          <p>Launch Your AI Receptionist with Rexpt.in</p>
        </div>
        <div className="ForMobile">

        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}
export default App;

// modal close 
